import * as interactionStudioCreators from '../../redux/actions/Interaction-studio-action-creators.js';
function storeInteractionConnect(store, data) {
  const objIS = interactionStudioCreators;
  if (objIS.hasOwnProperty(data.type)) {
    store.dispatch(interactionStudioCreators[data.type](data.payload));
  }
}

export default storeInteractionConnect;